"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TRANSLATIONS_QUERY_PARAMETER_NAME = exports.TRANSLATIONS_ENDPOINT = exports.TRANSLATIONS_CACHE_MAX_AGE = exports.FILE_HEADER = exports.ENTRIES_DELIMITER = exports.DYNAMIC_TRANSLATION_PREFIX = exports.DEFAULT_LOCALIZATION_FILES_FOLDER_NAME = void 0;
/**
 * The delimiter used to join entries in the generated files.
 */ var ENTRIES_DELIMITER = exports.ENTRIES_DELIMITER = '\n  ';
/**
 * Custom content prepended to all generated files.
 */ var FILE_HEADER = exports.FILE_HEADER = "/* istanbul ignore file */\n/**\n * DO NOT EDIT!\n * This file was autogenerated by npm script `localizations-codegen`.\n * Changes may cause incorrect behavior and will be lost when the file is regenerated.\n *\n * Run `npx localizations-codegen` to regenerate.\n */";
var TRANSLATIONS_CACHE_MAX_AGE = exports.TRANSLATIONS_CACHE_MAX_AGE = 15;
var TRANSLATIONS_ENDPOINT = exports.TRANSLATIONS_ENDPOINT = '/system/ajax/Localization/Translate';
var TRANSLATIONS_QUERY_PARAMETER_NAME = exports.TRANSLATIONS_QUERY_PARAMETER_NAME = 'keys';
var DYNAMIC_TRANSLATION_PREFIX = exports.DYNAMIC_TRANSLATION_PREFIX = '_dynamic_translation_';
var DEFAULT_LOCALIZATION_FILES_FOLDER_NAME = exports.DEFAULT_LOCALIZATION_FILES_FOLDER_NAME = 'resources'; //# sourceMappingURL=index.js.map
